import React from 'react';
import { DarwinCol, DarwinRow } from 'components/darwin-ui';
import DarwinTypography from 'components/darwin-ui/Typography';
import { SlidersOutlined } from '@ant-design/icons';
import { Control, FieldErrors } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import styles from '../../Users.module.css';
import { CreateUserFormData, CreateUserFormInputProps } from 'types/userTypes';
import { InputType } from 'types/genericTypes';
import { GenericInput } from 'components/ui/GenericInput';

const { Title } = DarwinTypography;

interface RoleDetailSectionProps {
  control: Control<CreateUserFormData>;
  errors: FieldErrors<CreateUserFormData>;
  canCreateEmailOrganizationRelation: boolean;
  assignableRoles: { id: string; name: string }[];
  isOwner?: boolean;
}

export const RoleDetailSection: React.FC<RoleDetailSectionProps> = ({
  control,
  errors,
  canCreateEmailOrganizationRelation,
  assignableRoles,
  isOwner,
}) => {
  const { t } = useTranslation();

  const firstColumnInputs: CreateUserFormInputProps = [
    {
      inputType: InputType.DROPDOWN,
      fieldName: 'role',
      label: t('create-user-form.role'),
      showRequiredAsterisk: true,
      inputRules: { required: t('create-user-form.role-required') },
      dropdownData:
        assignableRoles?.map(role => ({
          ...role,
          label: role.name,
        })) || [],
      disabled: !canCreateEmailOrganizationRelation || isOwner,
    },
  ];

  const secondColumnInputs: CreateUserFormInputProps = [
    {
      inputType: InputType.INPUT,
      fieldName: 'jobTitle',
      label: t('create-user-form.job-title'),
      showRequiredAsterisk: false,
      inputRules: {},
      disabled: !canCreateEmailOrganizationRelation,
    },
  ];

  return (
    <>
      <Title level={5} className={styles.userFormRowTitle}>
        <SlidersOutlined /> {t('create-user-form.role-detail')}
      </Title>
      <DarwinRow className={styles.userFormRow} gutter={16}>
        <DarwinCol span={12}>
          {firstColumnInputs.map(input => (
            <GenericInput
              key={input.fieldName}
              control={control}
              errors={errors}
              {...input}
            />
          ))}
        </DarwinCol>
        <DarwinCol span={12}>
          {secondColumnInputs.map(input => (
            <GenericInput
              key={input.fieldName}
              control={control}
              errors={errors}
              {...input}
            />
          ))}
        </DarwinCol>
      </DarwinRow>
    </>
  );
};
